import { useEffect, useState } from 'react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'

const links = [
  ['/', 'Home'], ['/services', 'Services'], ['/projects', 'Projects'],
  ['/about', 'About'], ['/contact', 'Contact'],
]

export function PublicLayout() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const location = useLocation()
  const isHome = location.pathname === '/'

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => { setMenuOpen(false) }, [location.pathname])

  return (
    <div className="public-layout">
      <header className={`bw-header ${isHome ? 'bw-header-home' : ''} ${scrolled || !isHome ? 'is-solid' : ''} ${menuOpen ? 'menu-open' : ''}`}>
        {!isHome && (
          <Link className="bw-header-logo" to="/" aria-label="Blazin Welding & Fabrication LLC home">
            <img src="/images/branding/logos/blazin-logo-480.webp" width="480" height="240" alt="Blazin Welding & Fabrication LLC" />
          </Link>
        )}
        <button className="bw-menu-toggle" type="button" aria-expanded={menuOpen} aria-controls="public-navigation" onClick={() => setMenuOpen((open) => !open)}>
          <span /><span /><span /><span className="sr-only">Toggle navigation</span>
        </button>
        <nav id="public-navigation" className="bw-nav" aria-label="Main navigation">
          {links.map(([to, label]) => <NavLink key={to} to={to}>{label}</NavLink>)}
          <NavLink className="bw-nav-login-mobile" to="/login">Login</NavLink>
        </nav>
        <div className="bw-header-actions">
          <a className="bw-phone-link" href="tel:+14257506340"><small>Call now</small>425.750.6340</a>
          <Link className="bw-button bw-button-outline bw-button-compact bw-header-login" to="/login">Login</Link>
          <Link className="bw-button bw-button-primary bw-button-compact" to="/quote">Get a quote</Link>
        </div>
      </header>
      <main><Outlet /></main>
      <footer className="bw-footer">
        <div className="bw-footer-main">
          <div className="bw-footer-brand">
            <Link to="/" aria-label="Blazin Welding home"><img src="/images/branding/logos/blazin-logo-480.webp" width="480" height="240" loading="lazy" alt="Blazin Welding & Fabrication LLC" /></Link>
            <p>Professional welding and custom fabrication focused on strength, precision, and quality workmanship.</p>
            <a className="bw-footer-phone" href="tel:+14257506340">425.750.6340</a>
          </div>
          <div className="bw-footer-column"><h2>Company</h2><Link to="/">Home</Link><Link to="/about">About</Link><Link to="/projects">Projects</Link><Link to="/contact">Contact</Link></div>
          <div className="bw-footer-column"><h2>Services</h2><Link to="/services">Welding</Link><Link to="/services">Custom fabrication</Link><Link to="/services">Repair & modification</Link><Link to="/services">Mobile welding</Link></div>
          <div className="bw-footer-column bw-footer-contact">
            <h2>Plan your project</h2>
            <Link className="bw-button bw-button-primary" to="/quote">Get a free quote</Link>
            <address className="bw-footer-details">
              <span>Lake Stevens, WA</span>
              <a href="mailto:Brandon@getblazinwelding.com">Brandon@getblazinwelding.com</a>
              <span>Monday-Friday 8:00 AM - 5:00 PM</span>
            </address>
          </div>
        </div>
        <div className="bw-footer-bottom"><p>© {new Date().getFullYear()} Blazin Welding & Fabrication LLC</p><Link to="/login">Client / Employee Login</Link></div>
      </footer>
    </div>
  )
}
